// import $ from 'jquery';

let previousScrollY = 0;
function disableScroll() {

  previousScrollY = window.scrollY;
  $('html').css({
    marginTop: -previousScrollY,
    overflow: 'hidden',
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  });
  window.scrollTo(0, previousScrollY);
  $('body').addClass('hidden');
}

function enableScroll() {
  $('html').css({
    marginTop: 0,
    overflow: 'visible',
    left: 'auto',
    right: 'auto',
    top: 'auto',
    bottom: 'auto',
    position: 'static',
  });
  window.scrollTo(0, previousScrollY);
  $('body').removeClass('hidden');
}

const btnMenu = () => {
  let btnMenu = $('.btn-mob-menu');
  if (btnMenu.length < 1) return;
  btnMenu.on('click', function () {
    let btn = $(this);
    let menuMobile = $('.header__wrapper--nav-block');
    let header = $('.header');

    if (btn.hasClass('active')) {
      enableScroll();
      menuMobile.slideUp({
        duration: 400,
        complete: function () {
          menuMobile.removeClass('active');
          btn.removeClass('active');
          header.removeClass('active');
        },
      });
    } else {
      disableScroll();
      menuMobile.slideDown({
        duration: 400,
        complete: function () {
          menuMobile.addClass('active');
          btn.addClass('active');
          header.addClass('active');
        },
      });
    }
  });

  // dropdown menu (mobile)
  let linksHasChild = $('.menu-item-has-children > .arrow-down');
  if (linksHasChild.length >= 1) {
    linksHasChild.on('click', function (e) {
      if ($(e.target).hasClass('arrow-down')) {
        e.preventDefault();
        let thisLink = $(this);
        let nextElBlock = thisLink.next('ul');
        if (thisLink.hasClass('active')) {
          nextElBlock.slideUp({
            duration: 400,
            complete: function () {
              nextElBlock.removeClass('active');
              thisLink.removeClass('active');
              thisLink.prev('a').removeClass('active');
            },
          });
        } else {
          let activeContainerPrev = $('.arrow-down.active');
          if (activeContainerPrev.length >= 1) {
            activeContainerPrev.prev('a').removeClass('active');
            activeContainerPrev.removeClass('active');
            activeContainerPrev.next('ul').removeClass('active');
            activeContainerPrev.next('ul').slideUp({duration: 400});
          }

          nextElBlock.slideDown({
            duration: 400,
            complete: function () {
              nextElBlock.addClass('active');
              thisLink.addClass('active');
              thisLink.prev('a').addClass('active');
            },
          });
        }
      }
    });
  }

  $( window ).resize(function() {
    let menuMobile = $('.header__wrapper--nav-block');
    let header = $('.header');
    if (header.hasClass('active')) {
      enableScroll();
      menuMobile.removeClass('active');
      menuMobile.removeAttr("style");
      menuMobile.find('.menu-item-has-children > ul').removeAttr('style');
      $('.btn-mob-menu').removeClass('active');
      header.removeClass('active');
    } else {
      //enableScroll();
      menuMobile.removeAttr("style");
    }
  });
}

export default btnMenu;
